// ** Initial State
const initialState = {
    result_list: [],
    total: 0,
    sign: null,
    timestamp: null,
    endpoint: null,
    notification: null
}

const chatBot = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_BOT_LIST':
            return {
                ...state,
                result_list: action.data,
                total: action.total
            }
        default:
            return { ...state }
    }
}

export {
    chatBot
}